<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Press Releases</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createPress">Create Press Release</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="press.columns" :data="press.data">
                    <template slot="table-row" v-if="press.data.length">
                        <tr v-for="(item, index) in press.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.pressRoomContentId}}</td>
                          <!--<td><span v-if="item.contentOrder === 2">Press Release</span><span v-else>In the News</span></td>-->
                          <td><span v-if="item.contentOrder === 2">Press Release</span><span v-else>In the News</span></td>
                          <td><a :href="item.pdfUrl" :title="item.topicSubHead" target="_blank">{{item.topicSubHead}}</a></td>
                          <td>{{item.topicSubHeadContents}}</td>
                          <td>{{item.topicSubHeadDateFmt}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewPress(item)" v-tooltip.top-center="press.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editPress(item)" v-tooltip.top-center="press.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const pressColumns = ['Id', 'Type', 'Heading', 'Description', 'Date', 'Status', 'Operations'];
    export default {
        name: 'Press',
        components: {
            LTable,
        },
        data() {
        return {
          press: {
                tooltips: {
                    view: 'View Press Release',
                    edit: 'Edit Press Release',
                    delete: 'Inactivate Press Release',
                    activate:'Activate Press Release',
                },
                columns: [...pressColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchPress () {
            this.$store.dispatch('FETCH_PRESS')
                    .then((res) => {
                        console.log('returned press releases', res)
                        this.press.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewPress(message){
            this.$router.push({ name: 'PressDetail', params: { id: message.pressRoomContentId}})
        },
        editPress(message){
            this.$router.push({ name: 'EditPress', params: { id: message.pressRoomContentId}})
        },
        createPress(){
            this.$router.push({ name: 'CreatePress'})
        }
    },
    created() {
        this.fetchPress();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Press/Press.vue